/*
 * variables are read from env at compile time (npm run start or npm run build)
 * or from .env.{development,production}{,.local} respectively if not present in environment.
 * See also <https://create-react-app.dev/docs/adding-custom-environment-variables/>
 */
const config = {
  serverURL: process.env.REACT_APP_SERVER_URL,
  appId: process.env.REACT_APP_APP_ID,
};

export default config;
